module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_5@2x-ea46db9e3f5f69963ed630b9fb90d2bc.jpg";